import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Paginator, {
      first: $setup.first,
      rows: $props.rows,
      totalRecords: $props.totalRecords,
      rowsPerPageOptions: [10, 20, 30],
      page: $setup.currentPage,
      onPage: $setup.onPageChange
    }, null, 8, ["first", "rows", "totalRecords", "page", "onPage"])
  ]))
}